import React from 'react';
import PropTypes from 'prop-types';
import DrawerCaretIcon from '../../icons/utility/DrawerCaret';
import Link from '../../base/Link';

import {
  List,
  ListItem,
} from './styles';

export const LinksListComponent = ({ items }) => (
  <List>
    {
      items.map((item) => (
        <ListItem key={`list-item-${item.href}`}>
          <Link href={item.href} target={item.target || '_self'}>{item.label} <DrawerCaretIcon /></Link>
        </ListItem>
      ))
    }
  </List>
);

LinksListComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    target: PropTypes.string,
  })).isRequired,
};

LinksListComponent.defaultProps = { };

export default LinksListComponent;
